module.exports = __webpack_public_path__ + "i18n/it.e988a6cd7249d760aa0b9979cad63feb.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/it.json
// module id = 1540
// module chunks = 60